import { state } from "./tripsData";

export default {
  state
};
